import { verifyOtpResponse } from "@/lib/types/DTO";
import globalRouter from "../global-router";
import { newQC } from "@/lib/provider/react-query-provider/react-query";

export const login = ({
  accessToken,
  refreshToken,
  shopId,
  ...otherData
}: verifyOtpResponse) => {
  localStorage.setItem("agent_access_token", accessToken);
  localStorage.setItem("agent_refresh_token", refreshToken);
  localStorage.setItem("agent_shop_id", shopId);
  localStorage.setItem("agent_init_data", JSON.stringify(otherData));
  newQC.invalidateQueries();

  if (globalRouter && globalRouter.navigate) {
    globalRouter.navigate("/");
  } else {
    window.location.href = "/v-pos/";
  }
};

export const logout = () => {
  localStorage.removeItem("agent_access_token");
  localStorage.removeItem("agent_refresh_token");
  localStorage.removeItem("agent_shop_id");
  localStorage.removeItem("agent_init_data");
  newQC.clear();

  if (globalRouter && globalRouter.navigate) {
    globalRouter.navigate("/auth/otp");
  } else {
    window.location.href = "/v-pos/auth/otp";
  }
};
